// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Dashboard from './pages/Dashboard';
import Emergencias from './pages/Emergencias';
import Eventos from './pages/Eventos';
import Mapa from './pages/Mapa';
import Reportes from './pages/Reportes';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/emergencias" element={<Emergencias />} />
          <Route path="/eventos" element={<Eventos />} />
          <Route path="/mapa" element={<Mapa />} />
          <Route path="/reportes" element={<Reportes />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;